import { render } from "./Questions.vue?vue&type=template&id=1f36ece4&bindings={\"questions\":\"props\",\"currentQuestion\":\"setup\",\"handleQuestion\":\"setup\",\"nextQuestion\":\"setup\"}"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"
script.render = render

export default script